let pick_data5 = [
    {
        id : 104,
        imgurl : '/img/section7/section7_golf1.jpg',
        brand : 'CHAMPION',
        title : '7인치 나일론 카고 숏팬츠',
        persent : '',
        price : '',
        saleprice : '69,000',
    },
    {
        id : 105,
        imgurl : '/img/section7/section7_golf2.jpg',
        brand : 'DOUBLE FLAG',
        title : '아이보리 여성 라운드넥 반팔 티셔츠',
        persent : '23%',
        price : '69,000',
        saleprice : '53,090',
    },
    {
        id : 106,
        imgurl : '/img/section7/section7_golf3.jpg',
        brand : 'FJALLRAVEN',
        title : '피엘라벤 프로 라이트 쇼츠',
        persent : '5%',
        price : '189,000',
        saleprice : '179,550',
    },
    {
        id : 107,
        imgurl : '/img/section7/section7_golf4.jpg',
        brand : 'HAZZYS GOLF',
        title : '베이지 소프트 반팔 카라티',
        persent : '5%',
        price : '238,000',
        saleprice : '226,100',
    },
    {
        id : 108,
        imgurl : '/img/section7/section7_golf5.jpg',
        brand : 'HAZZYS GOLF WOMEN',
        title : '베이지 프리컷 플리츠 스커트',
        persent : '5%',
        price : '238,000',
        saleprice : '226,100',
    },
    {
        id : 109,
        imgurl : '/img/section7/section7_golf6.jpg',
        brand : 'PUMA',
        title : '푸마 웨이브 플립',
        persent : '31%',
        price : '39,000',
        saleprice : '26,910',
    },
    {
        id : 110,
        imgurl : '/img/section7/section7_golf7.jpg',
        brand : 'DAKS GOLF',
        title : '남성용 냉감 슬리브리스 이너',
        persent : '19%',
        price : '90,000',
        saleprice : '72,900',
    },
    {
        id : 111,
        imgurl : '/img/section7/section7_golf8.jpg',
        brand : 'CHAMPION',
        title : 'Champion French Terry 숏팬츠',
        persent : '12%',
        price : '79,000',
        saleprice : '69,000',
    }
]

export default pick_data5;